{
  "cancel": "Avbryt",
  "pendingText": "Dette kan ta en stund - vennligst vent.",
  "delete": "Slett",
  "login": "Logg inn",
  "close": "Lukk",
  "required": "Dette feltet kan ikke være tomt",
  "chatNewMessage": "Ny melding",
  "chatCloseNotification": "Lukk varsling",
  "noMoreArticles": "Ingen flere artikler"
}
